var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Section',{class:_vm.$style.facilities,attrs:{"compact":""}},[_c('Heading',{class:_vm.$style.heading},[_vm._v("Facilities")]),_c('RichText',{class:_vm.$style.text,attrs:{"data":_vm.text_before}}),_c('Ul',{class:_vm.$style.list},_vm._l((_vm.list),function(ref,key){
var label = ref.label;
return _c('Li',{key:key,class:_vm.$style.li},[_vm._v(_vm._s(label))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }